import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { CompanyBetaProgramsTabController } from '../controller/CompanyBetaProgramsController';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { getContext } from '../../../../componentHelpers/getters';

export class CompanyBetaProgramsTabWebComponent extends BaseWebComponentElement {
  public controller!: CompanyBetaProgramsTabController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompanyBetaProgramsTabController,
    });
  }

  public get context(): CompanyActionContext {
    return getContext.call(this);
  }
}
